$(function() {
    $('.l-account')
        .on('click', '.js-account-menu', function() {
            var $nav = $('.js-account-nav');

            $nav.slideToggle(250);
        })
        .on('click', '.js-account-filter-trigger', function() {
            var $filter = $('.js-account-filter');

            $filter.slideToggle(250);
        });
});
